<template>
  <div class="mirco-app-report preview">
    <micro-app
      :name="microName"
      :url="getUrl"
      iframe
      router-mode="native"
      baseroute="/microLsp/app-cci"
      :data="storeInfo"
      @datachange="handleDataChange"
    ></micro-app>
  </div>
</template>
<!-- cciMicroApp 问题件暂时去掉缓存keep-alive 避免问题件进去详情后无法返回等处理，临时方案-->
<script lang="ts">
import microApp from '@micro-zoe/micro-app';
import config from '@/config/user.env';
import { useStore } from 'vuex';
import { defineComponent, nextTick, reactive, ref, toRefs, watch, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { handleMicroBigDataTrack } from '@/utils/bigLogData/trackHelper';

export default defineComponent({
  setup() {
    const microName = 'app-cci';
    const storeInfo = ref({});
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
    });

    const route = useRoute();
    const router = useRouter();

    watch(route, (val) => {
      initPage();
    });

    const store = useStore();
    const getUrl = computed(() => {
      return config.microCciUrl;
    });
    const initPage = () => {
      const routeInfo = microApp.router.current.get(microName);
      if (routeInfo && microApp.router.decode(route.path).includes(microName)) {
        if (`/#${route.path}` !== routeInfo.fullPath) {
          nextTick(() => {
            microApp.router.push({ name: microName, path: `/#${route.path}` });
          });
        }
      }

      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;

      const { user, authority, currentTenant, appId, appList, btnPermissions } = toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        toNtp,
      };
    };

    const toNtp = () => {
      router.push('/ntp/mod/pdt/find-vehicles?ntp=/#/mod/pdt/find-vehicles');
    };

    onMounted(() => {
      // 记得修改子应用 id
      microApp.setData(microName, { path: route.path, query: route.query || {} });
      initPage();
    });
    const handleDataChange = (val: any) => {
      const data = val.detail.data;
      if (handleMicroBigDataTrack(data, route.path)) return;
    };

    return {
      microName,
      storeInfo,
      config,
      getUrl,
      handleDataChange,
    };
  },
  // computed: {
  //   ...mapGetters([
  //     'user',
  //     'authority',
  //     'visitedViews',
  //     'currentTenant',
  //     'appId',
  //     'tenantInfo',
  //     'appList',
  //     'btnPermissions',
  //   ]),
  // },
});
</script>
<style lang="less">
.mirco-app-report {
  height: 100%;

  micro-app[name='app-cci'] {
    width: 100%;
    height: calc(100% - 10px);
    .layout-content {
      padding: 10px;
    }
    .app-wrap .app-main {
      padding-top: 0;
    }
    .el-input--mini {
      .el-input__inner {
        height: 24px !important;
        line-height: 24px;
      }
    }
    .el-range-editor--mini.el-input__inner {
      height: 24px !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      padding: 5px 11px;
    }
    .el-button--mini,
    .el-button--mini.is-round {
      padding: 4px 11px;
      min-height: 24px;
    }
    .el-pagination .el-pager li,
    .el-pagination__editor.el-input .el-input__inner {
      height: 24px;
      line-height: 24px;
    }

    .root-panel {
      height: 100%;
    }
    .layout-content {
      // box-sizing: border-box;
    }
  }
}

micro-app {
  height: 100%;
}
</style>
